// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';


export default function ConfirmDialog(props) {

  const { onCancelClick, onConfirmClick } = props;

  const text = props.text || "Are you sure?"
  const confirmBtnCaption = props.confirmBtnCaption || "OK"
  const cancelBtnCaption = props.cancelBtnCaption || "Cancel"

  const handleCancelClick = () => {
    onCancelClick && onCancelClick();
  }


  const handleConfirmClick = () => {
    onConfirmClick && onConfirmClick();
  }

  const openDialog = props.open || false
  const selectCnt = props.selectCnt || 0

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={openDialog}
    >
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancelClick}>
          {cancelBtnCaption}
        </Button>
        <Button onClick={handleConfirmClick} variant="contained" >{confirmBtnCaption}</Button>
      </DialogActions>
    </Dialog>

  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  selectCnt: PropTypes.number,
  text: PropTypes.string,
  confirmBtnCaption: PropTypes.string,
  cancelBtnCaption: PropTypes.string,
  onConfirmClick: PropTypes.func,
  onCancelClick: PropTypes.func,
};